import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AcLineCountForSubstation } from '../models/network-structure.model';
import { ResponsePackage } from '../models/util.model';
import { SHARED_LIB_CONFIG, SharedLibConfig } from '../config/lib-config';
import { AcLineSegmentType, AcLineSelectForMapDataOut, SearchAcLineSegmentDto } from '../models/ac-line-segment.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AcLineSegmentService {
  private pathApi: string;
  constructor(
    private http: HttpClient,
    @Inject(SHARED_LIB_CONFIG) private config: SharedLibConfig,
  ) {
    this.pathApi = this.config.pathApi + 'cim/ACLine/';
  }

  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  getAll(obj: any) {
    return this.http.post(`${this.pathApi}getAll`, obj, {
      headers: this.headers,
      observe: 'response',
    });
  }

  create(obj: any) {
    return this.http.post(`${this.pathApi}create`, obj, {
      headers: this.headers,
      observe: 'response',
    });
  }

  getById(obj: any) {
    return this.http.post(`${this.pathApi}getById`, obj, {
      headers: this.headers,
      observe: 'response',
    });
  }

  getAcLinesBySubstationId(obj: any) {
    return this.http.get(
      `${this.pathApi}getAcLinesBySubstationId?substationId=${obj}`,
      {
        headers: this.headers,
        observe: 'response',
      },
    );
  }

  getCountBySubstationId(substationId: number) {
    return this.http.get<ResponsePackage<AcLineCountForSubstation>>(
      `${this.pathApi}getCountBySubstationId/${substationId}`,
      {
        headers: this.headers,
        observe: 'response',
      },
    );
  }

  getStats(acLineType: number) {
    return this.http.get(`${this.pathApi}getStats?acLineType=${acLineType}`, {
      headers: this.headers,
      observe: 'response',
    });
  }

  generateTemplate(utilityId: number) {
    return this.http.get(
      `${this.pathApi}generateTemplate?utilityId=${utilityId}`,
      {
        headers: this.headers,
        observe: 'response',
      },
    );
  }

  generateFeederBandUpdateTemplate(utilityId: number) {
    return this.http.get(
      `${this.pathApi}generateFeederBandUpdateTemplate?utilityId=${utilityId}`,
      {
        headers: this.headers,
        observe: 'response',
      },
    );
  }

  getAcLineSchematic(acLineId: number): Observable<any> {
    return this.http.get(`${this.pathApi}getSchema/${acLineId}`, {
      headers: this.headers,
      observe: 'response',
    });
  }

  uploadFile(data: any) {
    return this.http.post(`${this.pathApi}uploadFile`, data);
  }

  updateFeederBands(data: any) {
    return this.http.post(`${this.pathApi}updateFeederBands`, data);
  }

  generateBulkAcLineUpdateTemplate(utilityId: number) {
    return this.http.get(
      `${this.pathApi}generateBulkAcLineUpdateTemplate?utilityId=${utilityId}`,
      {
        headers: this.headers,
        observe: 'response',
      },
    );
  }

  bulkAcLineUpdate(data: any) {
    return this.http.post(`${this.pathApi}bulkAcLineUpdate`, data);
  }

  downloadAcLines(dataIn: any): Observable<any> {
    return this.http.post(`${this.pathApi}download`, dataIn, {
      headers: this.headers,
    });
  }

  getAcLinesBySubstationIdAdvancedMap(obj: any) {
    return this.http.get(
      `${this.pathApi}getAcLinesBySubstationIdAdvancedMap?substationId=${obj}`,
      {
        headers: this.headers,
        observe: 'response',
      },
    );
  }

  getHistory(acLineId: number): Observable<any> {
    return this.http.get(`${this.pathApi}getHistory/${acLineId}`, {
      headers: this.headers,
      observe: 'response',
    });
  }

  getAllForSelectMap(dataIn: SearchAcLineSegmentDto): Observable<HttpResponse<AcLineSelectForMapDataOut[]>> {
    return this.http.post<AcLineSelectForMapDataOut[]>(`${this.pathApi}getAllForSelectMap`, dataIn, {
      headers: this.headers,
      observe: 'response',
    });
  }

  getAllACLinesCached(dataIn: any): Observable<any> {
    return this.http.post(`${this.pathApi}getAllACLinesCached`, dataIn, {
      headers: this.headers,
      observe: 'response',
    });
  }

  getV3FeederStats(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}getV3FeederStats`, obj, {
      headers: this.headers,
      observe: 'response',
    });
  }
}
